import { App } from 'vue';
import TenantConfigService from '../services/tenant-config-service';

export default {
    install(app: App) {
        const configService = TenantConfigService;

        // Make config service available globally
        app.config.globalProperties.$tenantConfig = configService;

        // Provide for composition API
        app.provide('tenantConfig', configService);

        try {
            // Set document-level properties
            const config = configService.getCurrentTenantConfig();

            //// Update document title
            //document.title = config.content.tagline;

            // Update favicon (only if it isn't already set correctly by the
            // synchronous bootstrap script in index.html, to avoid an
            // unnecessary reload of the icon)
            const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
            if (favicon && config.branding.favicon && !favicon.href.endsWith(config.branding.favicon)) {
                favicon.href = config.branding.favicon;
            }

            // Set CSS custom properties for global theming
            const root = document.documentElement;
            root.style.setProperty('--tenant-primary-color', config.branding.primaryColor);
            root.style.setProperty('--tenant-secondary-color-10', config.branding.primaryColor10);
            root.style.setProperty('--tenant-secondary-color-Op08', config.branding.primaryColorOp08);
            root.style.setProperty('--tenant-secondary-color', config.branding.secondaryColor);

        } catch (error) {
            console.error('[TenantConfigPlugin] Failed to initialize tenant configuration:', error);
        }
    }
};